// besida events
export const EVENT_INIT = 'init';
export const EVENT_SET_LOCALE = 'setLocale';
export const EVENT_OPEN_DIALOG = 'openDialog';
export const EVENT_AUTO_OPEN_DIALOG = 'openAutoDialog';
export const EVENT_CLOSE_DIALOG = 'closeDialog';
export const EVENT_BACK_TO_CHAT_LIST = 'backToChatList';
export const EVENT_MARK_MSG_READ = 'markChatMessagesRead';

export const EVENT_OPEN_ROOM = 'openRoom';
export const EVENT_OPEN_ROOM_SUCCESS = 'openRoomSuc';
export const EVENT_CHATS_STATUS_CHANGE = 'chatsStatusChange';
export const CHAT_CHECK_LIST_LOAD_CONDITION = 'chatCheckListLoadCondition';
export const CHAT_LIST_LOAD = 'chatListLoad';
export const CHAT_LIST_LOAD_SUCCESS = 'chatCheckListLoadSuccess';

export const EVENT_AUTH_CHANGE_TAB = 'authChangeTab';
export const EVENT_AUTH_PHONE_EMAIL_CHANGE = 'authPhoneEmailChange';
export const EVENT_AUTH_PASSWORD_CHANGE = 'authPasswordChange';

export const EVENT_REGISTER_EMAIL_CHANGE = 'registerEmailChange';
export const EVENT_REGISTER_USERNAME_CHANGE = 'registerUserNameChange';
export const EVENT_REGISTER_PASSWORD_CHANGE = 'registerPasswordChange';
export const EVENT_REGISTER_AGREEMENT_TOGGLE = 'registerAgreementToggle';

export const EVENT_REGISTER_REG_TRACKER = 'registerRegFormTracker';
export const EVENT_REGISTER_AUTH_TRACKER = 'registerAuthFormTracker';

export const EVENT_DIALOG_SEND_CONTAINER = 'dialogSendContainer';
export const EVENT_DIALOG_CLEAR_CONTAINER = 'dialogClearContainer';
export const EVENT_DIALOG_SAW_MSG_MARK = 'dialogSawMsgMark';
export const EVENT_DIALOG_CHECK_FETCH_CONDITION = 'dialogCheckFetchCondition';
export const EVENT_DIALOG_FETCH_HISTORY = 'dialogFetchHistory';
export const EVENT_DIALOG_FETCH_HISTORY_SUCCESS = 'dialogFetchHistorySuccess';
export const EVENT_DIALOG_STAY_ON_SAME_SCROLL = 'dialogStayOnSameScroll';
export const EVENT_DIALOG_DISABLE_MSG_SCROLL = 'dialogDisableMsgScroll';
export const EVENT_DIALOG_SCROLL_AFTER_HIS_FETCH = 'dialogScrollAfterHisFetch';
export const EVENT_DIALOG_SWITCH_ROLE = 'dialogSwitchRole';
export const EVENT_DIALOG_SET_MSG_FROM_DRAFT = 'dialogSetMsgFromDraft';
export const EVENT_DIALOG_SEND_FILES = 'dialogSendFiles';
export const EVENT_DIALOG_TOGGLE_IMAGE_POPUP = 'dialogToggleImagePopup';

export const EVENT_CLIENT_SHOW_INFO = 'clientShowInfo';
export const EVENT_CLIENT_BACK_TAB = 'clientBackTab';
export const EVENT_CLIENT_CHANGE_TAB = 'clientChangeTab';

export const EVENT_COMPANY_SHOW_INFO = 'companyShowInfo';
export const EVENT_COMPANY_BACK_TAB = 'companyBackTab';
export const EVENT_COMPANY_CHANGE_TAB = 'companyChangeTab';

export const EVENT_BESIDA_PING = 'besidaPing';
export const EVENT_BESIDA_RERENDER = 'besidaRerenderChat';
export const EVENT_BESIDA_KNOCK_KNOCK = 'besidaKnockKnock';
export const EVENT_BESIDA_CONNECTED = 'besidaConnected';
export const EVENT_BESIDA_MSG_CHANGE = 'besidaMsgChange';
export const EVENT_BESIDA_BLOCK_INPUT = 'besidaBlockInput';
export const EVENT_BESIDA_UNBLOCK_INPUT = 'besidaUnblockInput';
export const EVENT_BESIDA_SEND_MESSAGE = 'besidaSendMessage';
export const EVENT_BESIDA_RETRY_SEND_MESSAGE = 'besidaRetrySendMessage';
export const EVENT_BESIDA_RETRY_SEND_FILE = 'besidaRetrySendFile';
export const EVENT_BESIDA_RETRY_SEND_FILE_CONTEXT = 'besidaRetrySendFileContext';
export const EVENT_BESIDA_SEND_MESSAGE_SUCCESS = 'besidaSendMessageSuc';
export const EVENT_BESIDA_SEND_CONTEXT = 'besidaSendContext';
export const EVENT_BESIDA_SEND_CONTEXT_SUCCESS = 'besidaSendContextSuc';
export const EVENT_BESIDA_CHAT_META_SUCCESS = 'besidaChatMetaSuc';
export const EVENT_BESIDA_SEND_TYPING = 'besidaSendTyping';
export const EVENT_BESIDA_CHAT_HISTORY_SUCCESS = 'besidaChatHistorySuc';
export const EVENT_BESIDA_MARK_MSG_READ = 'besidaMarkRead';
export const EVENT_BESIDA_MARK_MSG_READ_SUCCESS = 'besidaMarkReadSuc';
export const EVENT_BESIDA_SEND_BAN_LIST = 'besidaSendBanList';
export const EVENT_BESIDA_SEND_BAN_LIST_SUCCESS = 'besidaSendBanListSuccess';
export const EVENT_BESIDA_SEND_UNBAN_LIST = 'besidaSendUnbanList';
export const EVENT_BESIDA_SEND_UNBAN_LIST_SUCCESS = 'besidaSendUnbanListSuccess';
export const EVENT_BESIDA_INITIALIZED = 'besidaInitialized';
export const EVENT_BESIDA_INIT_FAIL = 'besidaInitFail';
export const EVENT_WINDOW_RESIZE = 'windowResize';


// transport
export const TR_AUTHENTICATE_USER = 'trAuthenticateUser';
export const TR_AUTHENTICATE_USER_SUCCESS = 'trAuthenticateUserSuccess';
export const TR_AUTHENTICATE_USER_FAIL = 'trAuthenticateUserFail';
export const TR_REGISTER_USER = 'trRegisterUser';
export const TR_REGISTER_USER_SUCCESS = 'trRegisterUserSuccess';
export const TR_REGISTER_USER_FAIL = 'trRegisterUserFail';
export const TR_LOAD_SERVER_POW_SUCCESS = 'trLoadServerPowSuccess';
export const TR_LOAD_SERVER_POW_FAIL = 'trLoadServerPowFail';
export const TR_GET_CLIENT_INFO = 'trGetClientInfo';
export const TR_GET_CLIENT_INFO_SUCCESS = 'trGetClientInfoSuccess';
export const TR_GET_CLIENT_INFO_FAIL = 'trGetClientInfoFail';
export const TR_GET_COMPANY_INFO = 'trGetCompanyInfo';
export const TR_GET_COMPANY_INFO_SUCCESS = 'trGetCompanyInfoSuccess';
export const TR_GET_COMPANY_INFO_FAIL = 'trGetCompanyInfoFail';
export const TR_SEND_ANALITICS_ACTION = 'sendAnaliticsAction';

// besida handlers
export const EVENT_BESIDA_RESULT = 'besidaResult';
export const EVENT_BESIDA_ERROR = 'besidaError';
export const EVENT_BESIDA_HELLO = 'besidaHello';
export const EVENT_BESIDA_MESSAGE = 'besidaMessage';
export const EVENT_BESIDA_MESSAGE_SUCCESS = 'EVENT_BESIDA_MESSAGE_SUCCESS';
export const EVENT_BESIDA_COUNTERS = 'besidaCounters';
export const EVENT_BESIDA_REGISTRY = 'besidaRegistry';
export const EVENT_BESIDA_TYPING = 'besidaTyping';
export const EVENT_BESIDA_MARK_READ = 'besidaMarkRead';
export const EVENT_BESIDA_ROOM = 'besidaRoom';
